import React, { useEffect, useState } from 'react';
import { getVisitStats } from '../services/visitService';

const FooterStats = () => {
    const [stats, setStats] = useState({ total: 0, today: 0, online: 0 });

    useEffect(() => {
        const loadStats = async () => {
            const data = await getVisitStats();

            // ✅ sécuriser les données
            setStats({
                total: data?.total || 0,
                today: data?.today || 0,
                online: data?.online || 0,
            });
        };

        loadStats();

        const interval = setInterval(loadStats, 120000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{ fontSize: '0.85rem', color: '#fff', textAlign: 'left' }}>
            <span>Visiteurs : </span>
            <strong>{stats.today}</strong> (Aujourd'hui) | 
            <strong> {stats.total}</strong> (Total) | 
            <span style={{ color: '#28a745' }}> ● </span> 
            <strong>{stats.online}</strong> en ligne
        </div>
    );
};

export default FooterStats;